<template>
  <div class="view-backlog">
    <app-content-title-back-home title="История обновлений" />
    <div class="view-backlog__wrapper row">
      <div
        class="col-12"
        v-for="(item, index) in backlogData"
        :key="item.version"
      >
        <div class="view-backlog__item">
          <div @click="openBody(index)" class="view-backlog__item-header">
            <h2 class="view-backlog__item-header-title">
              Версия: {{ item.version }}
            </h2>
            <app-btn-chevron
              :isOpen="item.isOpen"
              class="view-backlog__item-header-arrow"
            ></app-btn-chevron>
          </div>
          <collapse-transition>
            <div v-show="item.isOpen">
              <div class="view-backlog__item-body">
                <span class="view-backlog__item-date"
                  >Дата релиза: {{ item.date }}</span
                >
                <div
                  class="view-backlog__item-done"
                  v-if="item.done.length > 0"
                >
                  <h3 class="view-backlog__item-title">Выполнено:</h3>
                  <ul class="view-backlog__item-list">
                    <li
                      class="view-backlog__item-list-item"
                      v-for="(done, idx) in item.done"
                      :key="idx"
                    >
                      {{ done }}
                    </li>
                  </ul>
                </div>
                <div
                  class="view-backlog__item-feat"
                  v-if="item.feat.length > 0"
                >
                  <h3 class="view-backlog__item-title">В разработке:</h3>
                  <ul class="view-backlog__item-list">
                    <li
                      class="view-backlog__item-list-item"
                      v-for="(feat, idx) in item.feat"
                      :key="idx"
                    >
                      {{ feat }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </collapse-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BACKLOG } from '@/helpers/enums/static';
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'ViewBacklog',
  components: {
    AppContentTitleBackHome: () =>
      import('@/components/common/AppContentTitleBackHome'),
    AppBtnChevron: () => import('@/components/ui/AppBtnChevron'),
    CollapseTransition,
  },
  data: () => ({
    backlogData: BACKLOG,
  }),
  methods: {
    /**
     * Открытие контента аккордиона
     * @param index
     */
    openBody(index) {
      this.backlogData[index].isOpen = !this.backlogData[index].isOpen;
    },
  },
};
</script>

<style lang="scss">
.view-backlog {
  &__item {
    max-width: 900px;
    margin: auto;
    margin-bottom: 15px;
    background-color: $white;
  }

  &__item-header {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    cursor: pointer;
  }

  &__item-header-title {
    margin: 0;
    font-size: rem(20);
    font-weight: 300;
  }

  &__item-title {
    font-size: rem(16);
    font-weight: 300;
  }

  &__item-date {
    font-size: rem(16);
    font-weight: 300;
  }

  &__item-body {
    padding: 20px;
    padding-top: 0;
  }

  &__item-list {
    @include list-reset;

    display: flex;
    flex-direction: column;
    padding-left: 15px;
  }

  &__item-list-item {
    position: relative;

    &::before {
      position: relative;
      content: '-';
    }
  }
}
</style>
